import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  Button,
} from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'

export const SubmitEfficiencyForm = (props) => {
  const { submitEfficiency, handleSubmitRemark } = props
  const { open } = props
  const month = get(props, 'month')
  const lob = get(props, 'lob')
  const userNotApprovedTimesheets = get(props, 'userNotApprovedTimesheets.length', 0)
  return (
  /* eslint no-underscore-dangle: 0 */
    <div>
      <Modal
        isOpen={ open }
        toggle={ () => submitEfficiency('cancel') }
      >
        <HeaderForm toggle={ () => submitEfficiency('cancel') }>
          <HeadLabel>Submit Efficiency Resource</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container>
                    <Row>
                      <Title>Submitting Period</Title>
                    </Row>
                    <Row>
                      <Detail>{ month }</Detail>
                    </Row>
                    <Row>
                      <Title>LOB</Title>
                    </Row>
                    <Row>
                      <Detail>{ lob }</Detail>
                    </Row>
                    <Row>
                      <Title>Unapproved Timesheet</Title>
                    </Row>
                    <Row>
                      <Detail>{ userNotApprovedTimesheets }</Detail>
                    </Row>
                    <Row>
                      <Title>Remarks (Max 500 Character)</Title>
                    </Row>
                    <Row>
                      <TextArea
                        name="submit_remark"
                        onBlur={ (e) => handleSubmitRemark(e) }
                      />
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <SubmitButton
            color='success'
            onClick={ () => submitEfficiency('submit') }
          >Submit</SubmitButton>
        </ModalFooter>
      </Modal>
    </div>
  )
}

SubmitEfficiencyForm.propTypes = {
  submitEfficiency: PropTypes.func,
  open: PropTypes.bool,
  handleSubmitRemark: PropTypes.func,
}
SubmitEfficiencyForm.defaultProps = {
  submitEfficiency: () => {},
  open: false,
  handleSubmitRemark: () => {},
}

const TextArea = styled.textarea`
  width: 100%;
  border: 1px solid #cccccc;
  font-family: 'Gotham' !important;
`
const HeaderForm = styled(ModalHeader)`
  font-family: Gotham-Bold;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`
const Title = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 14px ;
  margin-left: 5px;
`
const Detail = styled(Label)`
  font-family: Gotham;
  font-size: 14px ;
  margin-left: 5px;
`
const SubmitButton = styled(Button)`
  font-family: Gotham;
  height: 30px;
  width: 70px;
  font-size: 12px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/form/submit-efficiency.js